<form>
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card custom-card">
            <div class="card-body">
                <div class="card custom-card">
                    <div class="row">
                        <div class="col-sm-6 text-center">
                            <h6>Generate Roll Number</h6>
                        </div>
                    </div>
                    <div class="card-body pl-1">
                        <div class="row clearfix">
                            <div class="col-sm-12 ">
                                <h6 class="main-content-label f10">
                                    Generate Roll Number
                                </h6>
                                <div class="row">
                                    <div class="col-sm-8 offset-sm-4">
                                        <mat-form-field appearance="outline" class="example-full-width" >
                                            <mat-label>
                                                Start Roll No
                                            </mat-label>
                                            <input required class="color" matInput placeholder="Start Roll No">
                                            <!-- formControlName="EsCode -->
                                            <!-- <mat-error class="margin_tp"
                                                *ngIf="ExamSubForm.controls['EsCode'].touched && ExamSubForm.controls['EsCode'].errors?.pattern">
                                                Please Enter Valid Data
                                             </mat-error> -->
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <button type="button"
                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base">
                                    Cancel
                            </button>
                            <button type="button"
                                class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2">
                     
                                    Continue
                            
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>